import { noop } from "@/utils";
import { ReactLegendComponentProps } from "@components/Charts/plugins/ReactLegendPlugin";
import Checkbox from "@components/Field/Field/Checkbox";

import styles from "./CheckboxLegend.module.css";

const CheckboxLegend: React.FunctionComponent<
  ReactLegendComponentProps & { className?: string }
> = ({ chart, item, onClick }) => {
  return (
    <Checkbox
      checked={!item.hidden}
      onClick={() => onClick && onClick(chart, item)}
      onChange={noop} // prevent warning about uncontrolled component
      label={item.text}
      className={styles.root}
      style={{
        // match the color of the dataset
        borderColor: item.fillStyle as string, // It's safe to cast this as string as long as we don't do any fancy gradient stuff
      }}
    />
  );
};

export default CheckboxLegend;
